//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UCheckboxes from 'cloud-ui.vusion/src/components/u-checkboxes.vue/index.vue';
import UCheckbox from 'cloud-ui.vusion/src/components/u-checkbox.vue/index.vue';
import UImage from 'cloud-ui.vusion/src/components/u-image.vue/index.vue';
export default {
    components: {
        UCheckboxes,
        UCheckbox,
        UImage,
    },
    props: {
        value: Array,
        list: Array,
        min: { type: Number, default: 0 },
        max: { type: Number, default: Infinity },
    },
    data() {
        return {
            currentValue: this.splitValue(),
        };
    },
    watch: {
        currentValue(currentValue) {
            this.$emit('input', currentValue);
        },
        value() {
            this.currentValue = this.splitValue();
        },
    },
    methods: {
        getCurrentImage(item) {
            if (item.files[0]) {
                return item.files[0].url;
            }
            return item.image;
        },
        splitValue() {
            // TODO value 如果是字符串需要转换一次
            return this.value || [];
        },
    },
};
